import { FailureRes } from "@smartrr/shared/req";
import { ERROR_TYPE } from "@smartrr/shared/types";

export type ErrorType =
  | "account_locked"
  | "code_used"
  | "code_expired"
  | "cannot_send_invite"
  | "no_email"
  | "not_enabled"
  | "server_error"
  | "too_many_email"
  | "too_many_otp"
  | "wrong_email"
  | "wrong_otp";

export enum CUSTOMER_FRONTEND_ENDPOINTS {
  SEND_MAGIC_LINK = "/auth/ml/send-magic-link",
  VERIFY_MAGIC_LINK = "/auth/ml/verify-magic-link",
}

export enum REQUEST_TYPE {
  LOGIN = "login",
}
export enum REQUEST_STATUS {
  SUCCESS = "success",
  ERROR = "error",
}

export enum QUERY_PARAMS {
  CID = "cid",
}

export interface SendMagicLinkResponse {
  type: string;
  status: number;
  message: string;
  account_status?: string;
}

export interface VerifyMagicLinkResponse {
  type: string;
  status: number;
  mlStatus?: string;
  message: string;
  confirmationHash?: string;
  email?: string;
  accountStatus?: string;
}

export enum PASSWORDLESS_STRATEGY {
  ONE_TIME_PASSWORD = "otp",
  MAGIC_LINK = "magic-link",
}

export type LoginError = {
  errorType?: ERROR_TYPE;
  localizedError: string;
  showTimer: boolean;
  initialMinute: number;
} & FailureRes;

export enum PASSWORDLESS_LOGIN_STEPS {
  LOGIN_FORM = "loginForm",
  LOGIN_SUCCESS = "loginSuccess",
  EMAIL_CALLBACK = "emailCallback",
}
